class Nav {
    constructor() {
        this.isTouch = document.querySelector('html').classList.contains('bx-touch');
        this.header = document.querySelector('.header');
        this.nav = this.header.querySelector('.js-nav-top');
        this.hamburger = this.header.querySelector('.js-toggle-nav');
    }

    init() {
        $(this.hamburger).on('click', e => this.handleHamburger(e));

        if (this.isTouch) {
            $(this.header)
                .on('touchstart', '.nav__arrow', e => this.handleMobileToggler(e));
        } else if ($(window).outerWidth() <= 1024) {
            $(this.header)
                .on('click', '.nav__arrow', e => this.handleMobileToggler(e));
        } else {
            $(this.header)
                .on('mouseenter', '.js-top-link:not(.is-opened)', e => this.handleOpen(e))
                .on('mouseleave', '.js-top-link.is-opened', e => {
                    e.preventDefault();

                    let $link = $(e.currentTarget),
                        $dropdown = $link.siblings('.nav__slide'),
                        $relatedEl = $(e.relatedTarget);

                    if (!$relatedEl.is($dropdown) && !$relatedEl.closest($dropdown).length) {
                        this.handleClose($link, $dropdown);
                    }
                })
                .on('mouseleave', '.nav__slide.is-opened', e => {
                    e.preventDefault();

                    let $dropdown = $(e.currentTarget),
                        $link = $dropdown.siblings('.js-top-link'),
                        $relatedEl = $(e.relatedTarget);

                    if (!$relatedEl.is($link) && !$relatedEl.closest($link).length) {
                        this.handleClose($link, $dropdown);
                    }
                });
        }
    }

    handleOpen(e) {
        e.preventDefault();

        let $this = $(e.currentTarget),
            $thisDropdown = $this.siblings('.nav__slide');

        let lvl = $this.data('lvl'),
            $openedLinkCurrentLvl = $(this.nav).find(`.js-top-link[data-lvl="${lvl}"].is-opened`),
            $openedDropdownCurrentLvl = $openedLinkCurrentLvl.siblings('.nav__slide');

        if ($openedLinkCurrentLvl.length) {
            this.handleClose($openedLinkCurrentLvl, $openedDropdownCurrentLvl);
        }

        if (!$thisDropdown.hasClass('is-opened')) {
            $thisDropdown
                .velocity('stop')
                .velocity('transition.fadeIn', {
                    delay: 50,
                    duration: 350,
                    begin() {
                        $thisDropdown.addClass('is-opened');
                        $this.addClass('is-opened');
                    }
                });
        }
    }

    handleClose($link, $dropdown) {
        $link.removeClass('is-opened');

        $dropdown
            .removeClass('is-opened')
            .velocity('stop')
            .css({
                display: 'none',
                opacity: '0'
            });
    }

    handleHamburger(e) {
        e.preventDefault();

        const $nav = $(this.nav);
        const $hamburger = $(this.hamburger);
        const $header = $(this.header);

        if ($nav.hasClass('is-open')) {
            $nav.velocity("fadeOut", {
                duration: 250,
                begin: function() {
                    $hamburger.removeClass('is-active');
                    $nav.removeClass('is-open');
                    $header.removeClass('nav-opened');
                },
                complete: function() {}
            });
        } else {
            $nav.velocity("fadeIn", {
                duration: 250,
                begin: function() {
                    $hamburger.addClass('is-active');
                    $header.addClass('nav-opened');
                },
                complete: function() {
                    $nav.addClass('is-open');
                }
            });
        }
    }

    handleMobileToggler(e) {
        let $arrow = $(e.target),
            $link = $arrow.siblings('.js-top-link'),
            $item = $arrow.parent('.nav__item'),
            $dropdown = $link.siblings('.nav__slide'),
            isOpened = $link.hasClass('is-opened');

        let lvl = $link.data('lvl'),
            $openedLinkCurrentLvl = $(this.nav).find(`.js-top-link[data-lvl="${lvl}"].is-opened`),
            $openedItemCurrentLvl = $openedLinkCurrentLvl.parent('.nav__item'),
            $openedDropdownCurrentLvl = $openedLinkCurrentLvl.siblings('.nav__slide');

        if ($openedLinkCurrentLvl.length) {
            $openedDropdownCurrentLvl
                .velocity('stop')
                .velocity('slideUp', {
                    duration: 350,
                    begin() {
                        $openedDropdownCurrentLvl.removeClass('is-opened');
                        $openedLinkCurrentLvl.removeClass('is-opened');
                        $openedItemCurrentLvl.removeClass('is-opened');
                    },
                    complete() {
                        //убить попробовать все инлайн стили
                    }
                });
        }

        if (!isOpened) {
            $dropdown
                .velocity('stop')
                .velocity('slideDown', {
                    duration: 350,
                    begin() {
                        $dropdown.addClass('is-opened');
                        $link.addClass('is-opened');
                        $item.addClass('is-opened');
                    }
                });
        }
    }
}

new Nav().init();



// WEBPACK FOOTER //
// ./frontend/components/navigation/navigation.js